import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { typeValidationVasActionTypes } from '../types/typeValidationVasActionTypes'
import { TypeValidationVas } from '../../interfaces/TypeValidationVas/TypeValidationVas'
import { getTypeValidationVasAction } from '../actions/TypeValidationVasAction'

export function* getTypeValidationVasAsync() {
  try {
    const { status, data }: AxiosResponse<TypeValidationVas[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeValidationVasApi}/GetDdlInfo`
    )

    if (status === 200) {
      yield put(getTypeValidationVasAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeValidationVasAction([], serverError.message))
  }
}

export function* watchGetTypeValidationVasAsync() {
  yield takeEvery(
    typeValidationVasActionTypes.GET_TYPE_VALIDATION_VAS,
    getTypeValidationVasAsync
  )
}
